import * as React from 'react'
import logo from '../../images/icon.png'
import Box from '@mui/material/Box'
import { AppBar, Typography, Toolbar } from '@mui/material'
import dayjs from 'dayjs'
import { Link } from 'gatsby'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const footerBarStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
}

const footerLinks = [
    {
        text: 'Aviso Legal',
        ref: '/legal',
    },
    {
        text: 'Política de Privacidad',
        ref: '/privacy',
    },
    {
        text: 'Términos y condiciones',
        ref: '/terms-conditions',
    },
    {
        text: 'Política de Cookies',
        ref: '/cookies',
    },
]

function Footer() {
    const theme = useTheme()
    const isLarge = useMediaQuery(theme.breakpoints.up('md'))
    return (
        <AppBar position="relative">
            <Box sx={footerBarStyles} ml={isLarge ? 8 : 2} mr={isLarge ? 8 : 2}>
                <Box>
                    <img
                        style={{ borderRadius: 4, marginRight: '8px' }}
                        width="40"
                        height="40"
                        src={logo}
                        alt="Convive"
                    />
                </Box>
                <Box
                    flexGrow={1}
                    flexDirection="row"
                    display={'flex'}
                    ml={isLarge ? 8 : 0}
                    gap={isLarge ? 4 : 1}
                >
                    {footerLinks.map((elem) => (
                        <Box>
                            <Link
                                key={elem.text}
                                style={{
                                    color: 'white',
                                    textDecoration: 'none',
                                }}
                                to={elem.ref}
                            >
                                {elem.text}
                            </Link>
                        </Box>
                    ))}
                </Box>
                <Typography
                    variant="caption"
                    color="white"
                    sx={{
                        ml: 'auto',
                        display: isLarge ? 'inline-block' : 'none',
                    }}
                >{`© ${dayjs().year()} Convive All rights reserved`}</Typography>
            </Box>
        </AppBar>
    )
}

export default Footer
